import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {environment} from 'src/environments/environment';
import {ResponseDto} from '@models/responseDto.model';
import {GroupsCurrentUser} from '@models/group-user.model';
import {Observable, shareReplay} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectSystemService {

  readonly groupsByCurrentUser$: Observable<ResponseDto<GroupsCurrentUser>> =
    this.http.get<ResponseDto<GroupsCurrentUser>>(
      `${environment.apiTMIdentityServer}/CustomerPortal/User/GetGroupsByCurrentUser`
    ).pipe(
      shareReplay({ bufferSize: 1, refCount: false })
    );

  constructor(protected http: HttpClient) { }

}
